import $moment from "moment";
import { Model } from "../Model";
import { ScopeDocumentTypes } from "../../constants/contract-enums";

export class ScopeOfWork extends Model {
  static props = {
    id: { type: Number },
    name: { type: String },
    created_at: { type: String },
    contract_id: { type: Number },
    type: { type: String, required: true },
    location: { type: String, required: true },
    project_type: { type: String, required: true },
    work_scope_items: { type: Array, default: [] },
    design_sheets: { type: Array, default: [] },
    design_sheets_ids: { type: Array, default: [] },
    scope_items_ids: { type: Array, default: [] },
    additional_services: { type: Array, default: [] },
    additional_services_ids: { type: Array, default: [] },
    change_orders: { type: Array, default: [] },
    change_orders_ids: { type: Array, default: [] }
  };

  constructor(parameters) {
    super(ScopeOfWork.props, parameters);
  }

  mapParametersToModel(parameters, props) {
    super.mapParametersToModel(parameters, props);
    if (parameters.work_scope_items) {
      this.design_sheets = parameters.work_scope_items.filter(
        i => i.type === ScopeDocumentTypes.DESIGN_SHEETS
      );
      this.design_sheets_ids = this.design_sheets.map(i => i.id);

      this.scope_items = parameters.work_scope_items.filter(
        i => i.type === ScopeDocumentTypes.CONSTRUCTION
      );
      this.scope_items_ids = this.scope_items.map(i => i.id);

      this.additional_services = parameters.work_scope_items.filter(
        i => i.type === ScopeDocumentTypes.DESIGN_ADDITIONAL
      );
      this.additional_services_ids = this.additional_services.map(i => i.id);

      this.change_orders = parameters.work_scope_items.filter(
        i => i.type === ScopeDocumentTypes.CHANGE_ORDER
      );
      this.change_orders_ids = this.change_orders.map(i => i.id);
    }
  }

  get createdDate() {
    return this.created_at ? $moment(this.created_at).format("MM/DD/YYYY") : "";
  }
}
